'use client';

import { useContext, Fragment } from 'react';

import { CpInfoContext } from './layoutContainer';

import style from './cpInfo.module.scss';

function CpInfo() {
    const infoData = useContext(CpInfoContext);
    const formatText = (text: string) => {
        if (text?.length > 0) {
            return text.split('\n').map((line, index) => (
                <Fragment key={index}>
                    <span>{line}</span>
                    {index < text.split('\n').length - 1 && <br />}
                </Fragment>
            ));
        } else {
            return '';
        }
    };
    return (
        <div className={style.cpInfo}>
            <div className={style.introduction}>{formatText(infoData.description)}</div>
            <div className={style.tagBar}>
                {infoData?.tags?.map((tag, tagIdx) => (
                    <div className={style.tag} key={`${tag}_${tagIdx}`}>
                        # {tag}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CpInfo;
